import { Module } from "wrapper6";
import Vue from "vue";

var $ = jQuery;

export default class CustomizeModal extends Module {

    ready(app) {

        if(typeof customizeModalData !== 'undefined' && $('#customize-modal').length){

            (function($) {
                new Vue({
                    el: '#customize-modal .modal-inner',

                    computed: {
                        active_variation_attributes: function() {

                            if(typeof this.selected_variation === 'object' && this.selected_variation.hasOwnProperty('attributes')) {
                                let detailed_variations = this.selected_variation_detailed;
                                let converts = this.getVariationAttributes(this.selected_variation);
                                for(let variation in converts){
                                    let variationName = variation;
                                    let current = converts[variationName];
                                    if(!current){
                                        variationName = variationName.replace('æ','ae').replace('ø','oe').replace('æ','ae').replace('å','aa');
                                        current = converts[variationName];
                                    }
                                    let newVariationName = variationName;
                                    if(!detailed_variations['attribute_'+newVariationName.toLowerCase()]) {
                                        newVariationName = newVariationName.replace('æ','ae').replace('ø','oe').replace('æ','ae').replace('å','aa');
                                    }
                                    if(detailed_variations['attribute_'+newVariationName.toLowerCase()]){
                                        converts[variationName] = current+', '+detailed_variations['attribute_'+newVariationName.toLowerCase()];
                                    }
                                }
                                return converts;
                            }

                            return [];
                        },
                        active_variation_image: function() {
                            if(typeof this.selected_variation === 'object' && this.selected_variation.hasOwnProperty('image')) {
                                return this.selected_variation.image.src;
                            }

                            return this.product_image;
                        },
                        total_sum: function() {
                            let price = 0;

                            if(typeof this.selected_variation === 'object') {
                                if(this.selected_variation.display_regular_price){
                                    price += Number(this.selected_variation.display_regular_price);
                                }else {
                                    price += Number(this.selected_variation.display_price);
                                }
                            }

                            this.getSelectedRelatedProductVariations().forEach((product) => {
                                if(product.type === 'variable') {
                                    if(product.variation.display_regular_price){
                                        price += Number(product.variation.display_regular_price) * product.variation.quantity;
                                    }else {
                                        price += Number(product.variation.display_price) * product.variation.quantity;
                                    }
                                } else {
                                    price += Number(product.price) * product.quantity;
                                }
                            });

                            return price;
                        },
                        get_discount_price: function() {

                            let price = 0;

                            if(typeof this.selected_variation === 'object') {
                                price += Number(this.selected_variation.display_price)
                            }

                            this.getSelectedRelatedProductVariations().forEach((product) => {
                                if(product.type === 'variable') {
                                    price += Number(product.variation.display_price) * product.variation.quantity;
                                } else {
                                    price += Number(product.price) * product.quantity;
                                }
                            });

                            return price / 100 * (100-customizeModalData.discount);
                        },
                        get_discount: function() {
                            return customizeModalData.discount;
                        }
                    },
                    data: {
                        ajaxurl: customizeModalData.ajaxurl,
                        attribute_colors: customizeModalData.attribute_colors,
                        attribute_titles: customizeModalData.attribute_titles,
                        attribute_types: customizeModalData.attribute_types,
                        attributes: customizeModalData.attributes,
                        shortcodes: customizeModalData.shortcodes,
                        available_variations: customizeModalData.available_variations,
                        page: 0,
                        page_titles: ['Produktattributter', 'Produkttilvalg', 'Bekræftelse'],
                        product_image: customizeModalData.product_image,
                        product_name: customizeModalData.product_name,
                        quickship_colors: customizeModalData.quickship_colors,
                        related_products: customizeModalData.related_products,
                        selected_attributes: customizeModalData.selected_attributes,
                        custom_variations: {},
                        selected_variation: {},
                        selected_variation_detailed: {},
                        discount: customizeModalData.discount
                    },
                    methods: {
                        canViewNextPage() {
                            if(this.page === 0) {
                                for(let slug in this.attributes) {
                                    if(!this.selected_attributes.hasOwnProperty(slug)) {
                                        return false;
                                    }
                                }
                            }

                            return this.page < this.page_titles.length - 1;
                        },
                        canViewPreviousPage() {
                            return this.page > 0;
                        },
                        getAttributeValueTitle: function getAttributeValueTitle(value) {

                            const regex = /\[.*\]/gm;
                            let m;
                            let shortcoded = false;

                            while ((m = regex.exec(value)) !== null) {
                                if (m.index === regex.lastIndex) {
                                    regex.lastIndex++;
                                }
                                m.forEach((match, groupIndex) => {
                                    shortcoded = true;
                                });
                            }

                            if(shortcoded){
                                if(this.shortcodes[value]) {
                                    value = this.shortcodes[value].label;
                                } else {
                                    let split = value.split(']');
                                    value = this.shortcodes[split[0]+']'].label+split[1];
                                }
                            }

                            return value.charAt(0).toUpperCase() + value.slice(1);
                        },
                        getAvailableAttributes() {
                            let attributes = $.extend(true, {}, this.attributes);

                            Object.keys(attributes).forEach((slug) => {
                                let splice = [];

                                attributes[slug].forEach((value, i) => {
                                    if(!this.isVariationAvailable(slug, value)) {
                                        splice.push(i);
                                    }
                                });

                                splice.reverse();

                                splice.forEach((i) => {
                                    attributes[slug].splice(i, 1);
                                });
                            });

                            return attributes;
                        },
                        getAvailableVariations(attributes) {
                            return this.available_variations.filter((variation) => {
                                for(let slug in attributes) {
                                    let value = attributes[slug];
                                    if(!variation.attributes.hasOwnProperty('attribute_' + slug) || ['', value].indexOf(variation.attributes['attribute_' + slug]) === -1) {
                                        return false;
                                    }
                                }

                                return true;
                            });
                        },
                        getSelectedRelatedProductVariations() {
                            let variations = [];

                            this.related_products.forEach((product) => {
                                product = $.extend(true, {}, product);

                                if(product.type === 'variable') {
                                    let p_variations = $.extend(true, [], product.variations);
                                    delete product['variations'];

                                    p_variations.forEach((variation) => {
                                        product = $.extend(true, {}, product);
                                        variation = $.extend(true, {}, variation);

                                        if(variation.quantity > 0) {
                                            product['variation'] = variation;

                                            variations.push(product);
                                        }
                                    });
                                } else {
                                    if(product.quantity > 0) {
                                        variations.push(product);
                                    }
                                }
                            });

                            return variations;
                        },
                        getVariationAttributes(variation) {
                            let attributes = {};

                            for(let slug in variation.attributes) {
                                attributes[this.attribute_titles[slug.substring(10)]] =
                                    this.getAttributeValueTitle(variation.attributes[slug]);
                            }

                            return attributes;
                        },
                        isVariationAvailable(attribute_slug, attribute_value) {
                            let attributes = $.extend(true, {}, this.selected_attributes);
                            attributes[attribute_slug] = attribute_value;

                            return this.getAvailableVariations(attributes).length >= 1;
                        },
                        saveToCart() {
                            let data = {
                                action: 'add_product_customization_items_to_cart',
                                main_variation: this.selected_variation.variation_id,
                                related_variations: {},
                                related_variation_details: {}
                            };

                            this.getSelectedRelatedProductVariations().forEach((product) => {
                                let variation_id = product.type === 'variable' ? product.variation.variation_id : product.id;

                                data.related_variations[variation_id] = product.type === 'variable' ?
                                    Number(product.variation.quantity) : Number(product.quantity);
                            });

                            data.related_variation_details = this.active_variation_attributes;

                            $.post(this.ajaxurl, data, (response) => {
                                if(response.hasOwnProperty('success') && response.success) {
                                    $('#customize-modal .close-modal').trigger('click');


                                    $.get(this.ajaxurl, {'action': 'mtt_update_nav_menu'}, function (response) {
                                        if (response != 0) {
                                            // $('#header-wrapper').html(response);
                                            $('.menu-mini-cart').addClass('shoppingActive');

                                            setTimeout(function () {
                                                $('.menu-mini-cart').removeClass('shoppingActive');
                                            }, 2500);
                                        }
                                    });

                                    location.reload();
                                } else {
                                    alert('An error occurred. Please try again');
                                }
                            });
                        },
                        prettyNumber(num) {
                            return num.toFixed(2)
                                .replace('.', ',')
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                        },
                        removeSelectedRelatedProductVariation(id) {
                            this.related_products.forEach((product) => {
                                if(product.type === 'variable') {
                                    product.variations.forEach((variation) => {
                                        if(variation.variation_id === id) {
                                            variation.quantity = 0;
                                        }
                                    });
                                } else if(product.id === id) {
                                    product.quantity = 0;
                                }
                            });
                        },
                        selectAttribute: function selectAttribute(slug) {
                            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                            var selected_attributes = this.selected_attributes;

                            var attribute_keys = Object.keys(this.attributes);

                            for (var i = attribute_keys.indexOf(slug) + 1; i < attribute_keys.length; i++) {
                                var _slug = attribute_keys[i];
                                // TOOD: If error check this line
                                // delete selected_attributes[_slug];
                            }

                            if (value != null) {
                                selected_attributes[slug] = value;
                            }

                            const regex = /\[.*\]/gm;
                            let m;
                            let shortcoded = false;

                            while ((m = regex.exec(selected_attributes[slug])) !== null) {
                                if (m.index === regex.lastIndex) {
                                    regex.lastIndex++;
                                }
                                m.forEach((match, groupIndex) => {
                                    shortcoded = true;
                                });
                            }

                            let options = [];
                            if(shortcoded){
                                $('.removeOnChange').remove();

                                let args = this.shortcodes[selected_attributes[slug]];

                                if(! options[selected_attributes[slug]] ){
                                    options[selected_attributes[slug]] = [];
                                }

                                for (value in args.options){
                                    options[selected_attributes[slug]].push(args.options[value].label);
                                }

                            }

                            this.$set(this, 'custom_variations', options);
                            this.$set(this, 'selected_attributes', selected_attributes);
                            this.$set(this, 'selected_variation', this.getAvailableVariations(selected_attributes)[0]);
                            this.$set(this, 'selected_variation_detailed', {});
                            this.$forceUpdate();
                        },
                        shortCodeFilter: function shortCodeFilter(shortcode){
                            return shortcode.replace('[','').replace(']','')
                        },
                        selectVariation: function selectVariation(shortcode, slug) {
                            let detail = {}
                            detail['attribute_'+slug] = $('#'+shortcode).val();
                            this.$set(this, 'selected_variation_detailed', detail);
                            this.$forceUpdate();
                        },
                    },
                    mounted() {
                        for(let attr in this.attributes) {
                            if(this.attributes[attr].length > 0 && !this.selected_attributes.hasOwnProperty(attr)) {
                                this.selected_attributes[attr] = this.attributes[attr][0];
                            }
                        }

                        if(Object.keys(this.selected_attributes).length > 0) {
                            this.$set(this, 'selected_variation', this.getAvailableVariations(this.selected_attributes)[0]);
                        }
                    }
                });

                $(document).on('click', '#customize-modal .close-modal', function() {
                    $(document.body).removeClass('customize-modal');
                    $(this).parents('#customize-modal').first().hide();
                });

                $(document).on('click', '.open-customize-modal', function() {
                    $(document.body).addClass('customize-modal');
                    $('#customize-modal').first().show();
                });
            })(jQuery);

        }
        
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_customize-modal.js